'use strict';

var core = require('core/wishlist/detail');

var productBase = require('core/product/base');
var wishlistHelpers = require('core/wishlist/components/helpers');
var zonos = require('../zonos');

var cardProductEventClickAddCart = function(e) {
    e.preventDefault();
    //$.spinner().start();
    var $this = $(this);
    var $cardProduct = $this.parents('.wishlist-card-product');
    var addToCartUrl = $this.data().url;
    var pid = $cardProduct.data('pid');
    var quantity = $cardProduct.find('.wishlist-card-product-quantity').val();
    var options = JSON.stringify($this.data().options);
    var listId = $cardProduct.attr('data-list-id');
    var listItemId = $cardProduct.attr('data-list-item-id');
    $.ajax({
        url: addToCartUrl,
        method: 'POST',
        data: {
            pid,
            quantity,
            options
        },
        dataType: 'html',
        success: function (data) {
            productBase.methods.handlePostCartAdd(data);
            $('body').trigger('product:afterAddToCart', data);
            productBase.methods.miniCartReportingUrl(data.reportingURL, data.error);
            //$.spinner().stop();

            // LBH custom - launch removal confirmation modal after adding to cart
            $('.wishlist-add-to-cart-text').removeClass('d-none').addClass('d-block');
            $('.wishlist-add-to-cart-text-sub-text').removeClass('d-none').addClass('d-block');
            $('.wishlist-delete-product-text').removeClass('d-block').addClass('d-none');

            $('#wishlistModalDeleteProduct').modal('show', $(this));
            $('#wishlistModalDeleteProduct')
            .attr({
                'data-list-id': listId,
                'data-list-item-id': listItemId
            })
            .data({
                listId: listId,
                listItemId: listItemId
            });
        },
        error: function () {
            //$.spinner().stop();
        }
    });
};

var deleteProductModalEventClickDelete = function(e) {
    e.preventDefault();
    var $modal = $('#wishlistModalDeleteProduct');
    var detailPageSize = wishlistHelpers.getUrlParam('sz') ? Number(wishlistHelpers.getUrlParam('sz')) : null;
    var toastHelpers = require('core/components/toast');

    $.spinner().start();
    $.ajax({
        url: $modal.data().url,
        method: 'POST',
        dataType: 'json',
        data: {
            listId: $modal.data().listId,
            listItemId: $modal.data().listItemId,
            detailPageSize: detailPageSize
        },
        success: function(data) {
            $.spinner().stop();
            if (data.error && data.error === true) {
                toastHelpers.methods.show('danger', data.message, true);
            } else {
                $(".wishlist-details-products").find("[data-list-item-id='" + $modal.data().listItemId + "']").parent().remove();
                wishlistHelpers.dynamicUpdateWishlistQuantity();
            }
            zonos.updateZonosPricing();
            $modal.modal('hide');
        },
        error: function() {
            $modal.modal('hide');
            $.spinner().stop();
        }
    });
}

var cardProductEventClickRemove = function(e) {
    e.preventDefault();
    $('#wishlistModalDeleteProduct').modal('show', $(this));
    $('.wishlist-add-to-cart-text').removeClass('d-block').addClass('d-none');
    $('.wishlist-add-to-cart-text-sub-text').removeClass('d-block').addClass('d-none');
    $('.wishlist-delete-product-text').removeClass('d-none').addClass('d-block');
};

var addCardProductEventListeners = function() {
    if ($('.wishlist-details').length) {
        $('body')
            .on('select', '.wishlist-card-product', module.exports.methods.cardProductEventSelect)
            .on('unselect', '.wishlist-card-product', module.exports.methods.cardProductEventUnselect)
            .on('click', '.wishlist-card-product-toggle', module.exports.methods.cardProductEventClickCheckbox)
            .on('change', '.wishlist-card-product-quantity', module.exports.methods.cardProductEventChangeQuantity)
            .on('click', '.wishlist-card-product-add', module.exports.methods.cardProductEventClickAddCart)
            .on('click', '.wishlist-card-product-remove', module.exports.methods.cardProductEventClickRemove)
            .on('keydown', '.wishlist-card-product-toggle', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    module.exports.methods.cardProductEventClickCheckbox.call(this, e);
                }
            });
    }
};

var unsetSelectedProductsState = function () {
    $('.wishlist-details-nav').addClass('open');
    $('.wishlist-details-deselect').addClass('d-none').attr('tabindex', -1);
    $('.wishlist-details-action-btns').find('button').attr('tabindex', 0);
    $('.wishlist-details-public-toggle').removeClass('d-none').addClass('show');
    $('#wishlistOverlayDetailSelected').trigger('close');
    $('.wishlist-details')
        .find('.wishlist-card-product')
        .trigger('unselect');
};

var toggleSelectedProductsState = function () {
    if ($('.wishlist-card-product[data-selected="true"]').length) {
        $('.wishlist-details-nav').removeClass('open');
        $('.wishlist-details-action-btns').find('button').attr('tabindex', -1);
        $('.wishlist-details-deselect').removeClass('d-none').attr('tabindex', 0);
        $('.wishlist-details-public-toggle').removeClass('show').addClass('d-none');
        if (
            $('.wishlist-card-product.product-type-master[data-selected="true"]').length
            || $('.wishlist-card-product.unavailable[data-selected="true"]').length
        ) {
            $('.wishlist-overlay-detail-selected-add').attr('disabled', true).attr('tabindex', -1);
        } else {
            $('.wishlist-overlay-detail-selected-add').attr('disabled', false).attr('tabindex', 0);
        }
        $('#wishlistOverlayDetailSelected').trigger('open');
    } else {
        unsetSelectedProductsState();
    }
};

var eventClickDeselect = function (e) {
    e.preventDefault();
    unsetSelectedProductsState();
};

var eventClickSelectAll = function (e) {
    e.preventDefault();
    $('.wishlist-details')
        .find('.wishlist-card-product')
        .trigger('select');
    toggleSelectedProductsState();
};

core.methods.deleteProductModalEventClickDelete = deleteProductModalEventClickDelete;
core.methods.cardProductEventClickAddCart = cardProductEventClickAddCart;
core.methods.cardProductEventClickRemove = cardProductEventClickRemove;
core.methods.toggleSelectedProductsState = toggleSelectedProductsState;
core.methods.unsetSelectedProductsState = unsetSelectedProductsState;
core.methods.eventClickDeselect = eventClickDeselect;
core.methods.eventClickSelectAll = eventClickSelectAll;
core.addCardProductEventListeners = addCardProductEventListeners;
module.exports = core;
